import React from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AppRouter from './AppRouter';
import { CurrentEnvironment, Environment } from './contexts/ConfigContext';

const App: React.FC = () => {
    return (
        <>
            {(CurrentEnvironment !== Environment.Production) && <div className='dev-banner'>
                This is a test site, you may encounter stability issues and bugs.
                <a href="https://cod.cadesignform.dk/">Click here</a> to open the production site
            </div>}
            <AppRouter />
            {(CurrentEnvironment !== Environment.Production) && <ReactQueryDevtools initialIsOpen={false} />}
        </>
    );
};

export default App;